import { orderBy } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { Groups, PROVINCES } from '@sm360/widget-commons-forms';

class AddressSection extends React.Component {
    componentWillMount() {
        this.provinces = orderBy(
            PROVINCES.map((option) => {
                return {
                    value: option.code,
                    label: LocaleService.t(option.transKey),
                };
            }),
            ['value']
        );
    }

    render() {
        const { contactValue, hasBeenSubmit, handleFormGroupChange } = this.props;

        return (
            <section>
                <label className="sr-text is-bold">{LocaleService.t('DEPOSIT.HOME_ADDRESS_SECTION_TITLE')}</label>
                <Groups.AddressGroup
                    values={contactValue}
                    labels={{
                        address: LocaleService.t('COMMONS_FORMS.CONTACT.ADDRESS'),
                        address2: LocaleService.t('COMMONS_FORMS.CONTACT.ADDRESS_2'),
                        city: LocaleService.t('COMMONS_FORMS.CONTACT.CITY'),
                        postalCode: LocaleService.t('COMMONS_FORMS.CONTACT.POSTAL_CODE'),
                        province: LocaleService.t('COMMONS_FORMS.CONTACT.PROVINCE'),
                    }}
                    onChange={handleFormGroupChange}
                    provinces={this.provinces}
                    hasBeenSubmit={hasBeenSubmit}
                />
            </section>
        );
    }
}

AddressSection.propTypes = {
    contactValue: PropTypes.string.isRequired,
    handleFormGroupChange: PropTypes.func.isRequired,
    hasBeenSubmit: PropTypes.bool.isRequired,
};

AddressSection.displayName = 'AddressSection';

export default AddressSection;



// WEBPACK FOOTER //
// ./src/components/AddressSection/AddressSection.jsx